import FixaButton from "@coworker/apprestructured/src/shared/wrappers/FixaButton/FixaButton";
import { FixaListViewItem } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListViewItem";
import { FixaModal } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModal";
import { FixaModalFooter } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalFooter";
import { FixaModalHeader } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalHeader";
import { FixaSheets } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaSheets";
import { useTranslation } from "@coworker/locales";
import { FixaModalBody } from "@coworker/apprestructured/src/shared/wrappers/FixaModal/FixaModalBody";
import { FixaListView } from "@coworker/apprestructured/src/shared/wrappers/FixaListView/FixaListView";

export type Item = {
  label: string;
  value: string;
};

type SelectItemSheetProps = {
  items: Item[];
  itemValue: string;
  title: string;
  visible: boolean;
  emphasised?: boolean;
  onItemValueChange: (itemValue: string) => void;
  onCloseClick: () => void;
  onConfirmClick: () => void;
};

function SelectItemSheet({
  items,
  itemValue,
  title,
  visible,
  emphasised = false,
  onItemValueChange,
  onCloseClick,
  onConfirmClick,
}: SelectItemSheetProps) {
  const { t } = useTranslation();

  return (
    <FixaModal
      visible={visible}
      handleCloseBtn={onCloseClick}
      data-testid="SelectItem-FixaModal"
    >
      <FixaSheets
        header={<FixaModalHeader title={title} closeBtnClick={onCloseClick} />}
        footer={
          <FixaModalFooter renderBorder>
            <FixaButton
              type="primary"
              fluid
              text={t("confirmString")}
              onClick={onConfirmClick}
              disabled={!itemValue}
            />
          </FixaModalFooter>
        }
        fullSize
      >
        <FixaModalBody>
          <FixaListView id="SelectItem-ListView">
            {items.map((item) => (
              <FixaListViewItem
                key={item.value}
                title={item.label}
                onChange={() => onItemValueChange(item.value)}
                control="radiobutton"
                emphasised={emphasised}
                controlProps={{
                  checked: item.value === itemValue,
                  value: item.value,
                }}
              />
            ))}
          </FixaListView>
        </FixaModalBody>
      </FixaSheets>
    </FixaModal>
  );
}

export default SelectItemSheet;
